/// <reference path="../../lib/app.d.ts" />

	import {StickerPanel} from "./sticker-panel";
import {Collection} from "../lib/event-interface";
import {SamplerPanel} from "./sampler-panel";
import {EmojiConverter} from "../lib/emoji-converter";
import {Application} from "../application/application";
import {NotificationManager} from "./notification";
import logging from "../utils/log";
export interface ChatMessage
	{
		type : string;

		style   ?: string;
		from    ?: string;
		content ?: string;
		image   ?: string;
		send    ?: string;
		giftID  ?: string;
		gift    ?: string;
		stickerID ?: number;
	}

	/**
	 * A wrapper class around the chat panel view.
	 * Exposes methods to add messages and callbacks to retrieve user-entered messages
	 * Handles resizing
	 */
	export class ChatPanel
	{
		TAG = "[Sxc.Chat.ChatPanel]";

		private $msgWrapper: JQuery;
		private $msgBox: JQuery;
		private $scrollBox: JQuery;
		private $header: JQuery;
		private $form: JQuery;
		private $input: JQuery;
		private $button: JQuery;
		private $notifyBox: JQuery;

		private notify: NotificationManager;
		private disabled: boolean;

		public onMessageEntered: (message: string) => void;
		public onStickerSent: (stickerID: string) => void;

		private heightRatio: number = 0.5;

		private opened : boolean;
		private resizeable: boolean;
		private toggleable: boolean;

		private ctrlDownState = false;

		private height: number;
		private padding: number;

		private stickerPanel : StickerPanel;

		private msgBoxStickToBottom : boolean = true;
		public event : Collection;

		constructor(private $root: JQuery,
		            private samplerPanel: SamplerPanel,
		            private emojiConverter: EmojiConverter,
		            private app: Application,
		            private onSizeChange: Function = null)
		{
			this.event = new Collection("chat");

			// Initialize variables
			this.$msgWrapper = $root.find(".sxcc-chat-messages-wrapper");
			this.$scrollBox = $root.find(".sxcc-chat-messages-scroll");
			this.$msgBox = $root.find(".sxcc-chat-messages");
			this.$header = $root.find("header");
			this.$form = $root.find(".sxcc-chat-form");
			this.$input = this.$form.find("input");
			this.$button = this.$form.find("button");
			this.$notifyBox = $root.find(".sxcc-chat-notification");

			this.notify = new NotificationManager(this.$notifyBox);
			this.notify.onClick = () => this.setOpened(true);

			this.notify.onOpen = () =>
			{
				if (this.samplerPanel) this.samplerPanel.setCoverSize(this.$notifyBox.height());
			};

			this.notify.onClose = () =>
			{
				if (this.samplerPanel) this.samplerPanel.setCoverSize(0);
			};

			// Initialize event handlers

			this.preventOverScroll();
			this.initResizeHandler();
			// this.initEmojiHandler();
			// this.initStickerHandler();
			this.initFormEvents();

			this.stickerPanel = new StickerPanel(
				this.$root.find(".sxcc-stickers"),
				this.emojiConverter,
				this.app,
				(emoji : string) =>
				{
					this.onMessageEntered(emoji);
					this.stickerPanel.toggle(false);
					this.$input.focus();
					// let text = this.emojiConverter.unicodeToAscii(emoji);
					//
					// let el = <HTMLInputElement> this.$input[0];
					// let doc = <any> document;
					// text = ' ' + text + ' ';
					// let val = el.value, endIndex, startIndex, range;
					// if (typeof el.selectionStart != 'undefined' && typeof el.selectionEnd != 'undefined') {
					// 	startIndex = el.selectionStart;
					// 	endIndex = el.selectionEnd;
					// 	el.value = val.substring(0, startIndex) + text + val.substring(el.selectionEnd);
					// 	el.selectionStart = el.selectionEnd = startIndex + text.length;
					// } else if (typeof doc.selection != 'undefined' && typeof doc.selection.createRange != 'undefined') {
					// 	el.focus();
					// 	range = doc.selection.createRange();
					// 	range.text = text;
					// 	range.select();
					// }
					//
					// this.stickerPanel.toggle(false);
					// this.$input.focus();
				},
				(stickerID : string) =>
				{
					// logging.log("onStickerSelected", stickerID);
					this.onStickerSent(stickerID);
					this.stickerPanel.toggle(false);
					this.$input.focus();
				},
				() => {
					this.$input.focus();
				}
			);

			this.$root.find("button[data-action=stickers]").click(e => {
				e.stopImmediatePropagation();
				if (this.disabled) return;
				this.stickerPanel.toggle();
				this.$input.focus();
			});

			$(".sxcc-fixed-body").find("button[data-action=stickers]").click((e) => {
				e.stopImmediatePropagation();
				if (this.disabled) return;
				this.stickerPanel.toggle();
				this.$input.focus();
			});

			$(".sxcc-fixed-body").find("button[data-action=sendmsg]").click((e) => {
				$('.sxcc-chat-form-input').val($(e.currentTarget).attr("data-msg"));
				$('.sxcc-chat-form').submit();
				$('.sxcc-chat-form-input').val('');
			});

			this.$root.find("*").each((i, item) =>
			{
				let $item = $(item);
				if (!$item.children().length) {
					$item.html(this.emojiConverter.unicodeToImage($item.html()));
				}
			});

			let $stickerButton = this.$form.find("button[data-action=stickers]");
			let $sendButton = this.$form.find("button[data-action=send]");

			$stickerButton.on("mouseenter", () => {
				$stickerButton.addClass("hover");
				$sendButton.removeClass("hover");
			});
			$stickerButton.on("mouseleave", () => {
				$stickerButton.removeClass("hover");
				$sendButton.addClass("hover");
			});
			$sendButton.on("mouseenter", () => {
				$stickerButton.removeClass("hover");
				$sendButton.addClass("hover");
			});
			$sendButton.on("mouseleave", () => {
				$stickerButton.removeClass("hover");
				$sendButton.addClass("hover");
			});
			$sendButton.addClass("hover");

		}

		private initEmojiHandler()
		{
			let $emojiList = this.$root.find(".sxcc-emoji-list");

			// Handle the emoji button
			this.$root.find(".sxcc-emoji button").on("click", (e) =>
			{
				e.stopImmediatePropagation();
				if (this.disabled) return;

				if (!$emojiList.hasClass("sxc-visible")) {
					$(document).one("click", (e2) =>
					{
						if (!$.contains($emojiList[0], e2.target)) {
							$emojiList.removeClass("sxc-visible");
						}
					});
				}

				$emojiList.toggleClass("sxc-visible");
				this.$input.focus();
			});

			// Handle click on emojis

			this.$root.find(".sxcc-emoji-list").find("button").on("click", (e) =>
			{
				var text = $(e.currentTarget).text();
				text = this.emojiConverter.unicodeToAscii(text);

				var el = <HTMLInputElement> this.$input[0];
				var doc = <any> document;
				text = ' ' + text + ' ';
				var val = el.value, endIndex, startIndex, range;
				if (typeof el.selectionStart != 'undefined' && typeof el.selectionEnd != 'undefined') {
					startIndex = el.selectionStart;
					endIndex = el.selectionEnd;
					el.value = val.substring(0, startIndex) + text + val.substring(el.selectionEnd);
					el.selectionStart = el.selectionEnd = startIndex + text.length;
				} else if (typeof doc.selection != 'undefined' && typeof doc.selection.createRange != 'undefined') {
					el.focus();
					range = doc.selection.createRange();
					range.text = text;
					range.select();
				}
				this.$root.find(".sxcc-emoji-list").removeClass("sxc-visible");
				this.$input.focus();
			});
		}

		private initResizeHandler() : void
		{
			this.$header.on("click", () =>
			{
				this.toggle();
			});

			this.$header.on('mousedown', (e) =>
			{
				if (!this.resizeable) return;

				let startH = this.$root.height();
				let startY = e.pageY;

				$(document).on('mouseup.sxccboxresize', (e) =>
				{
					// If mouse not moved, or just a bit: click.
					if (Math.abs(e.pageY - startY) < 5)
					{
						this.setOpened(!this.opened);
						if (this.opened) {
							this.$input.focus();
						}
					}
					else
					{
						if (this.opened) {
							if (this.onSizeChange) this.onSizeChange(this.heightRatio);
						}
					}

					$(document)
						.off('mouseup.sxccboxresize')
						.off('mousemove.sxccboxresize');
				});

				$(document).on('mousemove.sxccboxresize', (e) =>
				{
					if (!this.opened) return;
					this.scrollDown(() => {
						let newH = startH + (startY - e.pageY);
						this.setHeightPx(newH);
					});
				});
			});
		}

		private initFormEvents() : void
		{
			let ctrlKeyCode = 17; let cmdKeyCode = 91;

			$(document).keydown((e) => {
				if (e.keyCode == ctrlKeyCode || e.keyCode == cmdKeyCode) this.ctrlDownState = true;
			}).keyup((e) => {
				if (e.keyCode == ctrlKeyCode || e.keyCode == cmdKeyCode) this.ctrlDownState = false;
			});

			this.$form.on("submit", (e) =>
			{
				e.preventDefault();

				if (this.disabled) return;

				this.scrollDown(() =>
				{
					let val = this.$input.val();
					val = val.trim();

					if (val !== "" && this.onMessageEntered) {
						val = this.emojiConverter.asciiToUnicode(val);
						let successful : unknown = this.onMessageEntered(val);

						if (successful as boolean)
						{
							this.$root.find(".sxcc-emoji-list").removeClass("sxc-visible");
							this.$input.val("");
						}
					}
				});
			});

			this.$input.on("keydown", (e) =>
			{
				const scrollTop = this.$scrollBox.sxcCustomScroll2("scrollTop");
				const height = this.$scrollBox.height();
				const scroll = (x) => this.$scrollBox.scrollTo(x);

				switch (e.keyCode)
				{
					// case 27: // Esc
					// 	this.stickerPanel.toggle(false);
					// 	break;

					case 33: // Pg Up
						scroll(scrollTop - height);
						e.preventDefault();
						break;

					case 34: // Pg Down
						scroll(scrollTop + height);
						e.preventDefault();
						break;

					case 38: // Up
						scroll(scrollTop - 20);
						e.preventDefault();
						break;

					case 40: /// Down
						scroll(scrollTop + 20);
						e.preventDefault();
						break;

					case 45: // CTRL / CMD + INS
					case 86: // CTRL / CMD + V
						if (this.ctrlDownState) {
							e.preventDefault();
							return false;
						}

						break;
				}
			});
			this.$input.on("paste", (e) => {
				e.preventDefault();
				return false;
			});

			let that = this;

			this.$scrollBox.sxcCustomScroll2("init", {
				onScroll(st, sh, h)
				{
					let isAtBottom = st + h >= sh - 1;

					if (isAtBottom) {
						that.msgBoxStickToBottom = true;
						that.$root.find(".sxcc-chat-autoscroll").hide();
					} else {
						that.msgBoxStickToBottom = false;
						that.$root.find(".sxcc-chat-autoscroll").show();
					}
				}
			});

			this.$root.find(".sxcc-chat-autoscroll").click(() => {
				this.scrollDown(() => {}, true);
			})
		}

		addMessage(message : ChatMessage, forceJump : boolean = false) : void
		{
			this.scrollDown(() =>
			{
				const $msgWrapper = $("<div />")
					.addClass("sxcc-message-wrapper")
					.addClass("sxcc-message-type-" + message.type)
					.appendTo(this.$msgBox);

				const $msg = $("<div />")
					.addClass("sxcc-message")
					.appendTo($msgWrapper);

				const $msgInner = $("<div />")
					.addClass("sxcc-message-inner")
					.appendTo($msg);

				if ("style" in message)
					$msgWrapper.addClass("sxcc-message-style-" + message.style);

				let content;

				switch (message.type)
				{
					case "gift":
						if ("image" in message && message.image) {
							$("<div class=\"sxcc-message-image\" />")
								.append($("<img />").attr("src", message.image))
								.appendTo($msgInner);
						}

						content = $("<div />").text(message.content).html();
						content = this.emojiConverter.unicodeToImage(content, content.length <= 2);

						$("<span class=\"sxcc-message-content\">")
							.append($("<div />").text(message.gift))
							.append($("<div />").html(content))
							.appendTo($msgInner);

						break;

					case "tip":
					case "tip_smarttoy":

						content = $("<div />").text(message.content).html();
						content = this.emojiConverter.unicodeToImage(content, content.length <= 2);

						$("<span class=\"sxcc-message-content\">")
							.html(content)
							.appendTo($msgInner);

						break;

					case "error":

						content = $("<div />").text(message.content).html();
						content = this.emojiConverter.unicodeToImage(content, content.length <= 2);

						$("<span class=\"sxcc-message-content\">")
							.html(content)
							.appendTo($msgInner);

						break;

					case "welcome":
					case "statuschange":

						if ("image" in message && message.image) {
							$("<div class=\"sxcc-message-image\" />")
								.append($("<img />").attr("src", message.image))
								.appendTo($msgInner);
						}

						content = $("<div />").text(message.content).html();
						content = this.emojiConverter.unicodeToImage(content, content.length <= 2);


						$("<span class=\"sxcc-message-content\">")
							.html(content)
							.appendTo($msgInner);

						break;

					case "chat":

						content = $("<div />").text(message.content).html();
						content = this.emojiConverter.unicodeToImage(content, content.length <= 2);
						let from = "from" in message ? message.from : null;

						$("<span class=\"sxcc-message-from\">")
							.text(from)
							.appendTo($msgInner);

						//$msgInner.append(": ");
						$("<span class=\"sxcc-message-content\">")
							.html(content)
							.appendTo($msgInner);

						break;

					case "sticker":
					{
						content = $("<div />")
							.append(this.stickerPanel.getStickerImg(message.stickerID)).html();

						let from = "from" in message ? message.from : null;

						$("<span class=\"sxcc-message-from\">")
							.text(from)
							.appendTo($msgInner);

						$("<span class=\"sxcc-message-content\">")
							.html(content)
							.appendTo($msgInner);

						break;
					}

					default:
						logging.error(this.TAG, "Unhandled message type", message);
				}

				if (message.style !== "member") {
					this.addNotification(message, $msgWrapper);
				}

			}, forceJump);

		}

		addNotification(message : ChatMessage, $msg : JQuery)
		{
			$msg = $msg.clone();
			this.notify.add($msg, 5000);
		}

		flashMessage(message : ChatMessage)
		{
			if (message.style === "performer")
			{
				this.$header.addClass("sxcc-chat-flash");
			}
		}

		clear()
		{
			this.$msgBox.empty();
		}

		disable()
		{
			this.$root.addClass("sxcc-disabled");
			this.$input.prop("disabled", true);
			this.$button.prop("disabled", true);
			this.$form.prop("disabled", true);
			this.stickerPanel.disable();
			this.disabled = true;
		}

		enable()
		{
			this.$root.removeClass("sxcc-disabled");
			this.$input.prop("disabled", false);
			this.$button.prop("disabled", false);
			this.$form.prop("disabled", false);
			this.stickerPanel.enable();
			this.disabled = false;
		}

		setOpened(opened : boolean)
		{
			// logging.log(this.TAG, "setOpened", opened, this.toggleable);
			if (!this.toggleable) return;

			this.opened = opened;
			if (opened) {
				this.notify.clear();
				this.setHeight(this.resizeable
					? (this.heightRatio ? this.heightRatio : 0.5)
					: true);
			} else {
				this.setHeight(null);
			}

			this.$root
				.removeClass("sxcc-chat-opened sxcc-chat-closed")
				.addClass(opened ? "sxcc-chat-opened" : "sxcc-chat-closed");

			this.event.trigger("stateChange", this.opened, this.toggleable, this.resizeable, this.$root.height());

			if (opened) {
				setTimeout(() => {
					this.$root.find("button[data-action=send]").addClass("hover");
				}, 500);
			} else {
				this.$root.find("button[data-action=send]").removeClass("hover");
			}

			this.scrollDown(() => {});
		}

		setResizable(resizeable : boolean)
		{
			// logging.log(this.TAG, "setResizeable", resizeable);
			this.resizeable = resizeable;

			if (1 || this.opened) this.setHeight(true);

			let action = resizeable ? "addClass" : "removeClass";
			this.$root[action]("sxcc-chat-resizable");

			this.event.trigger("stateChange", this.opened, this.toggleable, this.resizeable, this.$root.height());
		}

		setToggleable(toggleable : boolean)
		{
			// logging.log(this.TAG, "setToggleable", toggleable, this.opened);
			this.toggleable = toggleable;

			let action = toggleable ? "addClass" : "removeClass";
			this.$root[action]("sxcc-chat-toggleable");

			this.event.trigger("stateChange", this.opened, this.toggleable, this.resizeable, this.$root.height());

		}

		setHeightPx(px)
		{
			// logging.log(this.TAG, "setHeightPx", px);
			this.setHeight(Math.max(400, Math.min(this.height, px)) / this.height);

		}

		/**
		 * Sets the chat size in percent.
		 */
		setHeight(size)
		{
			let sizeInPx;

			if (size === true) {
				// Full height
				sizeInPx = this.height;
			}
			else if (size) {
				sizeInPx = Math.round(this.height * size);
				sizeInPx = Math.max(100, sizeInPx);
				this.heightRatio = size;
			}
			else {
				if (this.opened) {
					sizeInPx = Math.round(this.height * this.heightRatio);
					sizeInPx = Math.max(100, sizeInPx);
				} else {
					sizeInPx = this.$header.height();
				}
			}

			//logging.log(this.TAG, "setHeight ->", sizeInPx, "px", this.height, this.heightRatio);

			this.$root.css({
				top: this.height - sizeInPx + this.padding,
				height: sizeInPx
			});

			this.stickerPanel.triggerResize();

			this.event.trigger("stateChange", this.opened, this.toggleable, this.resizeable, sizeInPx);
		}

		getFontSize()
		{
			var current = parseInt(this.$msgBox.attr("data-fontsize"), 10);
			if (!current) current = 1;
			return current;
		}

		setFontSize(fontSize: any)
		{
			// logging.log(this.TAG, "[setFontSize]", fontSize);

			this.scrollDown(() => {
				this.$msgBox.attr(
					"data-fontsize",
					Math.max(1, Math.min(10, fontSize)));

				this.$notifyBox.attr(
					"data-fontsize",
					Math.max(1, Math.min(10, fontSize)));
			});
		}

		scrollDown(after : Function, force : boolean = false) : void
		{
			// logging.log(this.TAG, "scrollDown", force);
			after();

			this.$scrollBox.sxcCustomScroll2("update");

			if (force || this.msgBoxStickToBottom) {
				this.$scrollBox.sxcCustomScroll2("scrollTo", "bottom");
			}
		}

		updateHeader(text)
		{
			// let header = this.$header.data("content").replace("{{screenname}}", text);
			// logging.log("chatheader", text, header);
			this.$header.find(".name").text(text);
		}

		/**
		 * Places this component to the specified coordinates with the specified size
		 */
		public place(x : number, y : number, w : number, h : number) : void
		{
			this.height = h;
			this.padding = y;

			// logging.log(this.TAG, "place", x,y,w,h, this.toggleable, this.resizeable, this.opened);

			if(typeof this.app.options.chatIncludeType != 'undefined' && this.app.options.chatIncludeType == 'babesIFrame') {
				w = Number($('.sxcc-wrapper').width() / 4);
			}

			if (this.resizeable || this.toggleable)
			{
				this.$root.css({
					top: "",
					left: x,
					width: w,
				});
			} else {
				this.$root.css({
					top: y,
					left: x,
					width: w,
				});
			}

			if (this.toggleable && this.resizeable) {
				// FS
				this.setHeight(null);
			} else {
				// Norm, FB
				this.setHeight((!this.toggleable || this.opened) ? true : null);
			}
		}

		/**
		 * Clears placement css from this component
		 */
		public clearPlace() : void
		{
			this.$root.css({
				top: "",
				left: "",
				bottom: "",
				right: "",
				width: "",
				height: ""
			});
		}

		private preventOverScroll() : void
		{
			// this.$msgBox.on("mousewheel", (e) =>
			// {
			// 	var event = <any> e.originalEvent;
			// 	var d = event.wheelDelta || -event.detail;
			// 	this.$msgBox[0].scrollTop += ( d < 0 ? 1 : -1 ) * 30;
			// 	e.preventDefault();
			// });
		}

		isStickersVisible()
		{
			return this.stickerPanel.isVisible();
		}

		cancelStickers()
		{
			this.stickerPanel.toggle(false);
		}

		getHeight()
		{
			return this.$root.height()
		}

		getToggleable()
		{
			return this.toggleable;
		}

		getResizeable()
		{
			return this.resizeable;
		}

		getOpened()
		{
			return this.opened;
		}

		allowStickersBasedOn(base : "free" | "group" | "vx" | "normal")
		{
			this.stickerPanel.allowStickersBasedOn(base);
		}

		toggle(state : boolean = null)
		{
			// If resizable all is handled by mousedown/up events
			if (this.resizeable) return;
			if (!this.toggleable) return;

			state = state === null ? !this.opened : state;

			this.setOpened(state);
			if (this.opened) this.$input.focus();

		}
	}
